module.exports = __webpack_public_path__ + "img/onboarding_preview_img.216308e9.jpg";